import type { checklistAttachmentModel } from './selectors'
import { Button, CircleXIcon, PaperClipIcon, PlusIcon, SearchableOptionMenu } from '@st/theme'
import type { ChecklistMessage } from '~/features/checklists/module'

export function ChecklistAttachments({
  model,
  isAttachmentPickerOpen,
  emptyLabel,
  send
}: {
  model: ReturnType<typeof checklistAttachmentModel>
  send: (message: ChecklistMessage) => void
  isAttachmentPickerOpen: boolean
  emptyLabel: string
}) {
  return (
    <div className="space-y-3">
      <div className="space-y-2">
        {model.attached.length == 0 && (
          <div className="flex w-full items-center gap-2 rounded border border-gray-200 bg-stone-50 px-3 py-2 text-sm text-gray-500">
            <PaperClipIcon className="size-4 shrink-0" />
            <span>{emptyLabel}</span>
          </div>
        )}
        {model.attached.map(({ reference, key, label }) => {
          return (
            <div
              key={key}
              className="flex w-full items-center gap-2 rounded border border-gray-200 bg-stone-50 px-3 py-2 text-sm text-gray-800"
            >
              <PaperClipIcon className="size-4 shrink-0 text-gray-500" />
              <span className="min-w-0 flex-1 break-words">{label}</span>
              <button
                type="button"
                aria-label={`Remove ${label}`}
                className="shrink-0 text-gray-500 hover:text-gray-900"
                onClick={() =>
                  send({
                    type: 'attachmentRemoved',
                    reference
                  })
                }
              >
                <CircleXIcon className="size-4" />
              </button>
            </div>
          )
        })}
      </div>
      <div className="flex justify-end">
        <Button
          variant="link"
          leadingIcon={<PlusIcon className="size-4" />}
          onClick={() => send({ type: 'checklistPickerToggled' })}
        >
          Add attachment
        </Button>
      </div>
      {isAttachmentPickerOpen && (
        <SearchableOptionMenu
          title="Binder documents"
          placeholder="Search binder documents"
          emptyLabel="No matching documents"
          className="w-full"
          items={model.available}
          onRequestClose={() => send({ type: 'checklistPickerClosed' })}
          onSelect={(documentId) => send({ type: 'checklistAttachmentPicked', documentId })}
        />
      )}
    </div>
  )
}
